import { Permission } from '@insio/shared-types';
import { usePermissions } from '@/features/auth';
import { accountActions } from '../account/account-actions';

/**
 * Whether the caller may declare the current account a master account: account settings
 * permission, and the account not already managed by a master account.
 */
export function useCanDeclareMasterAccount(managedByMasterAccount: boolean): boolean {
  const { hasPermission } = usePermissions();
  return accountActions(
    { managedByMasterAccount, isMasterAccountOwnBooks: false },
    hasPermission(Permission.ACCOUNT_SETTINGS)
  ).declareMasterAccount;
}
